module.exports = __webpack_public_path__ + "static/media/close.96319464.svg";